import React from "react";
import PropTypes from "prop-types";
import UpperCaseText from "../../../utils/UpperCaseText";
import EMPButton from "../../../shared/components/EMPButton/EMPButton";
import { Grid, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { getMarketBrandPath } from "../../../utils/marketBrandUtils";
import { usesDealerExperienceRoutes } from "../../../utils/canadianPreorderExperience";

export const DashboardActions = (props) => {
  const { title, hideActionButton, t, user, buttonClassName } = props;
  const customerHandlingPath = usesDealerExperienceRoutes(user)
    ? getMarketBrandPath(user.market, user.brand, "/customer-handling")
    : "/customer-handling";

  return (
    <Grid container spacing={2} alignItems="center">
      {!hideActionButton && (
        <Grid item xs={12}>
          <Box textAlign="center">
            <EMPButton
              className={buttonClassName}
              href={customerHandlingPath}
              to={customerHandlingPath}
              variant="outlined"
            >
              {t("DealerDashboard.viewActions")}
            </EMPButton>
          </Box>
        </Grid>
      )}
      <Grid item xs={12}>
        <Box textAlign="center">
          <EMPButton
            className={buttonClassName}
            href={customerHandlingPath}
            buttonElement={Link}
            link={{
              pathname: customerHandlingPath,
            }}
            variant="text"
          >
            {UpperCaseText(title) === "ORDERS"
              ? t("DealerDashboard.viewSubmitted")
              : t("DealerDashboard.viewAll")}
          </EMPButton>
        </Box>
      </Grid>
    </Grid>
  );
};

DashboardActions.propTypes = {
  title: PropTypes.string.isRequired,
  hideActionButton: PropTypes.bool,
  buttonClassName: PropTypes.string,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    userType: PropTypes.string,
    brand: PropTypes.string,
    market: PropTypes.string,
  }).isRequired,
};

DashboardActions.defaultProps = {
  hideActionButton: false,
  buttonClassName: undefined,
};
